<template>
  <div>
    <p>
      <span class="remove-underline-animation">
        <a
          href="https://www.idrettsforbundet.no/digital/idrettsoppgjor/"
          target="_blank"
          rel="noopener noreferrer"
          class="secondary-variant--text"
        >{{ $t("publicPageStrings.readMore") }}&rarr;</a>
      </span>
    </p>
    <v-expansion-panels
      v-if="segmentCount > 1"
      flat
      tile
      :model-value="expandedSections"
      multiple
    >
      <v-expansion-panel
        v-for="(segment, index) of contentSegments"
        :key="index"
      >
        <v-expansion-panel-title>{{ segment.title }}</v-expansion-panel-title>
        <v-expansion-panel-text
          class="pt-4"
          style="white-space: pre-wrap"
        >
          {{
            segment.content
          }}
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <div
      v-for="(segment, index) of contentSegments"
      v-else-if="contentSegments"
      :key="index"
    >
      <h3 class="text-h3 mt-8 mb-5">
        {{ segment.title }}
      </h3>
      <p style="white-space: pre-wrap">
        {{ segment.content }}
      </p>
    </div>
  </div>
</template>

<script>
import HelpBarContentTypes from "@/enums/HelpBarContentTypes";
import { mapGetters } from "vuex";
import noHelp from '@/plugins/i18n/no/help';
import { useI18n } from 'vue-i18n';

const help = {
  no: noHelp
};

export default {
  name: "HelpContent",
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  computed: {
    ...mapGetters({
      contentType: "helpBarStore/contentType",
      expandedSections: "helpBarStore/expandedSections"
    }),
    segmentCount() {
      return Object.keys(this.contentSegments).length;
    },
    contentSegments() {
      const helpContentKey = Object.entries(HelpBarContentTypes)[this.contentType][0];
      const segments = help[this.locale][helpContentKey];
      return segments;
    }
  }
};
</script>
